import React from 'react';
import {FlatList, Image, ListRenderItemInfo, View} from 'react-native';
import {isEmpty} from 'lodash';

import Text from '/component/base/Text';
import {keyExtractor} from '/component/screen/ReleaseNotes/ReleaseNotes.util';

import {Content} from './Content';
import {styles} from './Section.style';

// Define the types for the Section's item prop
interface SectionProps {
  item: {
    title: string;
    imageUrl?: string;
    content: Array<{title: string; description: string; points: string[]}>;
  };
}

export const Section: React.FC<SectionProps> = ({
  item = {
    title: '',
    imageUrl: '',
    content: [],
  },
}: SectionProps) => {
  const {title, imageUrl, content} = item;

  const renderItem = ({item}: ListRenderItemInfo<any>) => (
    <Content item={item} />
  );

  return (
    <View style={styles.container}>
      <Text variant="heading" style={styles.title}>
        {title}
      </Text>
      {!isEmpty(imageUrl) && (
        <>
          <View style={styles.separator} />
          <Image
            style={styles.image}
            resizeMode="cover"
            source={{
              uri: imageUrl,
            }}
          />
        </>
      )}
      <FlatList
        data={content}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
      />
    </View>
  );
};
